import { gql } from '@apollo/client';

export const ADD_INTERVENTIONS_TO_PROGRAMME = gql`
  mutation addInterventionsToProgramme($input: AddInterventionsToProgrammeInput!) {
    programme: addInterventionsToProgramme(input: $input) {
      id
    }
  }
`;
